import ApiClient from 'clients/api_client'
import Pagination from 'entities/pagination'
import RecruiterDestinationCandidate from 'entities/user_notice/recruiter_destination_candidate'
import { TARGET_ALL } from 'entities/user_notice/constants/target_type'

export default class RecruiterDestinationCandidateClient {
  static getRecruiterDestinationCandidates(page, keyword = null, target = TARGET_ALL, options = {}) {
    const url = Routes.searchUserNoticeRecruiterDestinationCandidatesPath({ page })
    const params = {
      keyword,
      target
    }

    return ApiClient.post(url, params, options).then(({ data, headers }) => ({
      recruiterDestinationCandidates: data.map(r => RecruiterDestinationCandidate.fromJson(r)),
      pagination: Pagination.fromJsonLowerCased(headers)
    }))
  }
}
